import {Component, OnInit, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export class AlertDialogParams {
  constructor(
    public title: string = null,
    public description: string = null,
    public actionLabel: string = null,
    public panelClass: string = null,
    public backdropClass: string = null,
    public icon: string = null,
    public iconClass: string = null,
    public actionPosition: 'left' | 'center' | 'right' = 'center',
    public showAction: boolean = true,
    public autoFocus: boolean = true,
  ) {
  }
}

@Component({
  selector: 'terra-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
})
export class AlertDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
    if (this.data.panelClass) {
      this.dialogRef.addPanelClass(this.data.panelClass);
    }
  }
}
